module.exports = __webpack_public_path__ + "img/logo-sidebar-grey.52bf6bc2.svg";